document.addEventListener('DOMContentLoaded', (event) => {
    const passwordBtn = document.getElementById('passwordButton')
    if(passwordBtn) {
        passwordBtn.addEventListener('click', function () {
            let passField = document.getElementById('password');
            if (passField.type === "password") {
                passField.type = "text";
            } else {
                passField.type = "password";
            }
        });
    }

    console.log('password.js mounted');
});
